var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorites-tab"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.name))]),(_vm.showReddot)?_c('div',{staticClass:"reddot-box"},[_c('div',{staticClass:"reddot"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }